import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as API from '../../api/routes';
import {
  USER_GET_LIST,
  USER_CREATE,
  USER_GET_DETAIL,
  USER_UPDATE,
} from '../actions';

import {
  userGetListSuccessed,
  userGetListFailed,
  userCreateSuccessed,
  userCreateFailed,
  userUpdateFailed,
  userGetDetailFailed,
} from './actions';

function* userGetList({ callback }) {
  try {
    const res = yield call(API.userGetList);
    yield put(userGetListSuccessed(res.result));
    yield call(callback?.(res.result))
  } catch (error) {
    yield put(userGetListFailed(error.error_message));
  }
}

function* userCreate({ payload, callback }) {
  const { params } = payload;
  
  try {
    let data = new FormData();
    data.append('first_name', params.first_name)
    data.append('last_name', params.last_name)
    data.append('department_id', params.department_id)
    data.append('position_id', params.position_id)
    data.append('email', params.email)
    data.append('password', params.password)

    const res = yield call(API.userCreate, data);
    yield put(userCreateSuccessed(res.result));
    yield call(callback?.(res.result));

  } catch (error) {
    yield put(userCreateFailed(error.message));
  }
}

function* userGetDetail({ payload, callback }) {
  const { user_id } = payload;
  try {
    const res = yield call(API.userGetDetail, user_id);
    yield call(callback?.(res.result));
  } catch(error) {
    yield put(userGetDetailFailed(error.message));
  }
}

function* userUpdate({ payload, callback }) {
  const { id, params } = payload;
  let data = new FormData();
  data.append('first_name', params.first_name)
  data.append('last_name', params.last_name)
  data.append('department_id', params.department_id)
  data.append('position_id', params.position_id)
  params.password && data.append('password', params.password)

  try {
    const res = yield call(API.userUpdate, id, data);
    yield call(callback?.(res));
  } catch(error) {
    yield put(userUpdateFailed(error.message));
  }
}

export function* watchWorkers() {
  yield takeEvery(USER_GET_LIST, userGetList);
  yield takeLatest(USER_CREATE, userCreate);
  yield takeLatest(USER_GET_DETAIL, userGetDetail);
  yield takeLatest(USER_UPDATE, userUpdate);
}

export default function* rootSaga() {
  yield all([
    fork(watchWorkers)
  ]);
}